import React from "react";
import "./Facts.scss";

import first from "./assets/img/1.png";
import second from "./assets/img/2.png";
import third from "./assets/img/3.png";
import fact from "./assets/img/fact.svg";

const Facts = () => {
  return (
    <div className="facts" id="facts">
      <div className="container">
        <div className="facts-wrapper">
          <div className="facts-cards">
            <div className="facts__card">
              <img className="facts__card-image" src={first} alt="Факт №1" />
              <div className="facts__card-text">
                <span className="facts__card-text__fact">Факт №1</span>
                <span className="facts__card-text__number">2570 кг</span>
                <span className="facts__card-text__title">
                  Щеток переданы на переработку
                </span>
                <span className="facts__card-text__box">
                  <img src={fact} alt="Иконка SPLAT" />
                  <p className="facts__card-text__description">
                    Идея проекта – показать путь переработки и конечный продукт,
                    который будет произведен из собранного вторсырья. Мы хотим
                    показать людям, что отходы, в частности пластиковые – это
                    ресурс, который нужно использовать для создания новых
                    полезных вещей.
                  </p>
                </span>
              </div>
            </div>

            <div className="facts__card reversed">
              <div className="facts__card-text">
                <span className="facts__card-text__fact">Факт №2</span>
                <span className="facts__card-text__number">15 щеток</span>
                <span className="facts__card-text__title">
                  Необходимо для изготовления 1 плитки
                </span>
                <span className="facts__card-text__box">
                  <img src={fact} alt="Иконка SPLAT" />
                  <p className="facts__card-text__description">
                    Мы мечтаем о гармонии между человеком и природой и верим,
                    что забота о планете – высшее проявление осознанности
                    человека. Наша общая задача – заботиться о планете как о
                    собственном доме и относиться к окружающему миру так же, как
                    к самим себе, – бережно и с любовью. Так мы относимся к
                    ресурсам планеты и стремимся полностью нейтрализовать свой
                    экологический след.
                  </p>
                </span>
              </div>
              <img className="facts__card-image" src={second} alt="Факт №2" />
            </div>

            <div className="facts__card">
              <img className="facts__card-image" src={third} alt="Факт №3" />
              <div className="facts__card-text">
                <span className="facts__card-text__fact">Факт №3</span>
                <span className="facts__card-text__number">
                  1680 м<sup>2</sup>
                </span>
                <span className="facts__card-text__title">
                  Размер центральной площади города Окуловка в Новгородской
                  области выложенная плиткой из переработанного сырья
                </span>
                <span className="facts__card-text__box">
                  <img src={fact} alt="Иконка SPLAT" />
                  <p className="facts__card-text__description">
                    Мы хотим показать важность использования вторсырья в
                    производстве новых товаров, ведь это возможно!
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facts;
